import { z } from 'zod'

import { m } from '@/lib/paraglide/messages'

// A single cultivation parcel. paths/markers are optional geo-coords preserved
// from the backend (no map editor here) so editing never strips them.
function growerAreaSchema() {
    // acreage stays a string in the form (raw input) and is parsed to a number at
    // submit time — this keeps the zod input/output types aligned for the resolver.
    return z.object({
        // Stable id for foreign references (care-log parcels). New areas omit it
        // (the server mints one); existing areas must keep it — kept in the schema
        // so zod doesn't strip it out of the payload on submit.
        id: z.string().optional(),
        // Khoá nội bộ của form, KHÔNG gửi lên server (payload dựng bằng tay ở
        // trang sửa hộ). Giấy tờ đất được giữ dạng nháp theo khoá này vì vùng
        // vừa thêm chưa có `id` — server mới cấp lúc lưu.
        draftKey: z.string().optional(),
        // Auto-generated by the backend ("MVTNNN") and never entered/edited in
        // the UI. New areas submit an empty string; the server mints the code.
        code: z.string().trim().optional(),
        name: z.string().trim().min(1, m.validation_required()),
        acreage: z.string().refine((v) => v.trim() !== '' && Number(v) > 0, {
            message: m.validation_required(),
        }),
        note: z.string().trim(),
        paths: z.array(z.unknown()).optional(),
        markers: z.array(z.unknown()).optional(),
    })
}

export function createGrowerSchema() {
    return z.object({
        name: z.string().trim().min(1, m.validation_required()).max(255),
        // Tên thường gọi: không bắt buộc, chỉ để phân biệt các hộ trùng tên.
        nickname: z.string().trim().max(255).optional(),
        // Date inputs emit YYYY-MM-DD; empty string means "no date".
        birthday: z.string().optional(),
        phone: z.string().optional(),
        address: z.string().optional(),
        national_id: z.string().optional(),
        national_id_issued_date: z.string().optional(),
        national_id_issued_place: z.string().optional(),
        bank_number: z.string().optional(),
        bank_name: z.string().optional(),
        bank_account: z.string().optional(),
        areas: z.array(growerAreaSchema()),
        user_id: z.string().optional(),
    })
}

export type GrowerFormValues = z.infer<ReturnType<typeof createGrowerSchema>>
export type GrowerAreaFormValues = z.infer<ReturnType<typeof growerAreaSchema>>
